import { render, staticRenderFns } from "./ComponentRefContentType.vue?vue&type=template&id=6b9e7ff0"
import script from "./ComponentRefContentType.vue?vue&type=script&lang=js"
export * from "./ComponentRefContentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports